import { render } from "./CertificatesBuy.vue?vue&type=template&id=5f497c5e"
import script from "./CertificatesBuy.vue?vue&type=script&lang=js"
export * from "./CertificatesBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__